<template>
    <div class="help_center">
        <div style="display: flex;justify-content: center;">
            <div class="main-area" >
                <div style="text-align: right"><Button @click="addNew" class='assign' type="primary">+ 添加图片素材</Button></div>
                <div class="multiple">
                    <Table :columns="columns" :data="data" size="small" ref="table">
                        <div slot="operation" slot-scope="{ row }">
                            <a @click="editMaterial" style="padding-right:10px" :data-id="row.id">查看</a>
                            <a  @click="delMaterial" :data-id="row.id">删除</a>
                        </div>
                    </Table>
                </div>
                <div class="pager">
                    <Page :total="count" :page-size="20" :current="page" @on-change="changePage"
                          size="small" show-total show-elevator/>
                </div>
            </div>

            <Modal v-model="addMaterialModal"
                   title="添加信息"
                   @on-cancel="() => {addMaterialModal = false}"
                   @on-ok="saveMaterial">
                <Form ref="formValidate" :label-width="80">
                    <FormItem label="名称" prop="date">
                        <Input v-model="formData['ext_info']['name']" placeholder="请输入名称"></Input>
                    </FormItem>
                    <FormItem label="预览图" prop="date">
                        <div style="display: flex; justify-content: space-between;align-items: center; width: 90%">
                            <div v-if="formData.ext_info.imgURL"><img style="width: 80px; height: 126px;" :src="formData.ext_info.imgURL"></div>
                            <Button type="primary" @click="uploadImg">上传图片</Button>
                        </div>
                        <div>建议640*1008</div>
                    </FormItem>
                    <FormItem label="分类" prop="date">
                        <Select v-model="formData.type">
                            <Option v-for="item in categoryList" :value="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </Modal>
        </div>

        <Modal
                v-model="uploadModal"
                title="上传图片"
                @on-cancel="() => {uploadModal = false}"
                @on-ok="fileOk">
            <addFile ref="addFile" :needFileName="0" :fileFormat="['jpg','jpeg','png','gif']"></addFile>
        </Modal>
    </div>
</template>

<script>
    import addFile from '../tool/addFile.vue';
    import {mapGetters} from 'vuex';
    import {getMaterialList, saveMaterial, getMaterial, delMaterial} from '@/api/admin'

    export default {
        name: "materialManage",
        components: {
            addFile
        },
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
        data() {
            return {
                uploadType: '',
                uploadModal: false,
                addMaterialModal: false,
                addCategoryModal: false,
                categoryList: [
                    {label: '通用', value: 1},
                    {label: '节日', value: 2},
                    {label: '问答', value: 3},
                    {label: '名片', value: 4},
                    {label: '热门', value: 5},
                ],
                formData: {
                    type: 0,
                    ext_info: {imgURL: '','name': ''},
                },
                formDataCate: {name:''},
                data: [],
                page: 1,
                count: 0,
                columns: [
                    {
                        "title": "id",
                        "key": "id",
                        "width": 80,
                    },
                    {
                        "title": "名称",
                        "key": "name",
                        "width": 150
                    },
                    {
                        "title": "所属分类",
                        "key": "category_name",
                        "width": 230
                    },
                    {
                        "title": "添加时间",
                        "key": "created_at",
                        "width": 250
                    },
                    {
                        "title": "更新时间",
                        "key": "updated_at",
                        "width": 300,
                    },
                    {
                        "title": "操作",
                        "slot": "operation",
                        "width": 300,
                    }
                ]
            }
        },
        created(){
            this.getList();
        },
        methods: {
            changePage(e) {
                this.page = e;
                this.getList();
            },
            fileOk() {
                var that = this;
                that.formData['ext_info']['imgURL'] = that.$refs['addFile'].fileUrl;
                that.$refs['addFile'].clear();
            },
            async getList() {
                let that = this;
                let data = {token: that.token, page: this.page}
                let res = await getMaterialList(that, data);
                if (res.code == 1) {
                    that.data = res.data.list;
                    that.count = res.count;
                }
            },
            addNew() {
                let that = this;
                that.initFormData();
                this.addMaterialModal = true;
            },
            editMaterial(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                this.throttle(async function () {
                    let data = {token: that.token, id: id}
                    let res = await getMaterial(that, data);
                    if (res.code == 1) {
                        that.formData = res.data.item;
                        that.addMaterialModal = true;
                    }
                }, 1000);
            },
            delMaterial(e) {
                let that = this;
                let id = e.currentTarget.dataset.id;
                that.$Modal.confirm({
                    title: '确认删除吗？',
                    onOk: async() => {
                        that.throttle(async function () {
                            let data = {token: that.token, id: id}
                            let res = await delMaterial(that, data);
                            if (res.code == 1) {
                                that.$Message.success('删除成功');
                                that.getList();
                            }
                        }, 1000);
                    }
                })
            },
            saveMaterial() {
                let that = this;
                this.throttle(async function () {
                    let data = {token: that.token, formData: that.formData}
                    let res = await saveMaterial(that, data);
                    if (res.code == 1) {
                        that.$Message.success('保存成功');
                        that.initFormData();
                        that.getList();
                    }
                }, 1000);
            },
            uploadImg() {
                this.uploadModal = true;
            },
            initFormData() {
                this.formData = {
                    type: 0,
                    ext_info: {imgURL: '','name': ''},
                };
            }
        }
    }
</script>

<style scoped lang="less">
    .help_center {
        height: 100%;
        background: #f5f7f9;
    }

    .yl-flex {
        display: flex;
        justify-content: space-between;
    }
    .ivu-form-item{
        display: inline-block;
        width: 300px;
        margin-left: 15px;
    }
    .main-area{
        width: 100%; height: 300px; background-color: #FFFFFF; padding: 20px;
    }

    .multiple {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-top: 10px;

        .child-div {
            width: 85px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
            font-size: 12px;
        }
        span{
            font-size: 12px;
        }
        label{
            font-size: 12px;
        }
    }

    .delegate {
        justify-content: start;
        align-items: flex-end;
    }
    .dele {
        font-size: 12px;
        padding: 0 25px;
        border: 1px solid #e0e2e6;
        color: #666;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    .dele.active {
        padding: 5px 20px;
        background: #0092ff;
        color: #fff;
    }
    /deep/ .ivu-table table {
        width: 100% !important;
    }
</style>
